import { combineReducers } from 'redux'
import commonDucks from './commonDucks'
import commonLogDucks from './commonLogDucks'
import settingDucks from './settingDucks'
import userDucks from './userDucks'
import poupDucks from './poupDucks'
import notificationDucks from './notificationDucks'
import categorieDucks from './categorieDucks'

import chiNhanhDucks from './chiNhanhDucks'
import menuDucks from './menuDucks'
import duAnDucks from './duAnDucks'
import roleGroupDucks from './roleGroupDucks'
import heThongDucks from './heThongDucks'
import subAdminDucks from './subAdminDucks'

const rootReducer = combineReducers({
  common: commonDucks,
  commonLog: commonLogDucks,
  setting: settingDucks,
  user: userDucks,
  poup: poupDucks,
  notification: notificationDucks,
  categorie: categorieDucks,
  chiNhanh: chiNhanhDucks,
  menu: menuDucks,
  duAn: duAnDucks,
  roleGroup: roleGroupDucks,
  heThong: heThongDucks,
  subAdmin: subAdminDucks,
})

export default rootReducer
